import React, { useEffect, useState, useLayoutEffect } from 'react';
import { useLocation } from "react-router-dom";
import Navbar from '../../component/NavBar';
import Footer from '../../component/Footer';
import AniPaperHero from './AniPaperHero';
import AniPaperRoadmap from './AniPaperRoadmap';

const AniPaperPage = () => {
  const [notifyContent, setNotifyContent] = useState(false);
  const [closeLoading, setCloseLoading] = useState(false);
  const [isPageReady, setIsPageReady] = useState(false);
  const location = useLocation();
  // scroll to top of page after a page transition.
  useLayoutEffect(() => {
    document.documentElement.scrollTo({ top:0, left:0, behavior: "instant" });
  }, [location.pathname]);

  useEffect(() => {
    setTimeout(() => {
      if (isPageReady) {
        setCloseLoading(true);
        setTimeout(() => {
          setNotifyContent(true);
        }, 700);
      }
    }, 1000);
  }, [isPageReady]);

  return (
    <div className="bg-black">
      <div className={`fixed bg-black w-full h-full flex items-center justify-center overflow-y-hidden ${notifyContent ? 'hidden' : 'block'} transition-all duration-700 ${closeLoading ? 'opacity-0' : 'opacity-100'}`}>
        <img
          className={`w-[268px] h-auto animate-pulse`}
          src="/assets/mainV2/hero-loading.png"
          alt="hero loading"
        />
      </div>

      <div className={`relative bg-black flex flex-col items-center justify-center overflow-x-hidden transition-all duration-700 ${closeLoading ? 'opacity-100' : 'opacity-0'}`}>
        <Navbar isSticky/>
        <AniPaperHero setIsPageReady={setIsPageReady}/>
        <AniPaperRoadmap />
        <Footer />
      </div>
    </div>
  )
}

export default AniPaperPage;